export default "/images/vendor/flag-icons/flags/1x1/ms.svg?eda45363054639bb62a8e84a3e2db285";